import {
  CREATE_NEW_PASSWORD,
  LOGIN,
  LOGOUT,
  PORTAL_LOGIN,
  FORGOT_PASSWORD,
  RESET_PASSWORD,
} from "./types";

export const login = (email, password, onSuccess, onError) => {
  return {
    type: LOGIN,
    email,
    password,
    onSuccess,
    onError,
  };
};
export const logout = (onSuccess, onError) => {
  return {
    type: LOGOUT,
    onSuccess,
    onError,
  };
};

export const redirectedLogin = (token, onSuccess, onError) => {
  return {
    type: PORTAL_LOGIN,
    token,
    onSuccess,
    onError,
  };
};

export const createNewPassword = (data, onSuccess, onError) => {
  return {
    type: CREATE_NEW_PASSWORD,
    data,
    onSuccess,
    onError,
  };
};

export const ForgotPassword = (data, onSuccess, onError) => {
  return {
    type: FORGOT_PASSWORD,
    data,
    onSuccess,
    onError,
  };
};

export const resetPassword = (data, onSuccess, onError) => {
  return {
    type: RESET_PASSWORD,
    data,
    onSuccess,
    onError,
  };
};
